module.exports = __webpack_public_path__ + "media/images/lb/118-6a043d86b6548fa3bd561d8f67af0176.svg";